"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchyURLBuilder = void 0;
var Url_1 = require("../../../utils/Url");
var HierarchyURLBuilder = /** @class */ (function () {
    function HierarchyURLBuilder() {
    }
    HierarchyURLBuilder.prototype.buildUrl = function (request) {
        var params = [];
        if (request.maximumDepth !== undefined) {
            params.push([
                HierarchyURLBuilder.MAXIMUM_DEPTH_PARAM,
                request.maximumDepth.toString(),
            ]);
        }
        if (request.maximumPageSize !== undefined) {
            params.push([
                HierarchyURLBuilder.MAXIMUM_PAGE_SIZE_PARAM,
                request.maximumPageSize.toString(),
            ]);
        }
        if (request.pageCursor !== undefined) {
            params.push([
                HierarchyURLBuilder.LAST_EVALUATED_PARAM,
                request.pageCursor.toString(),
            ]);
        }
        if (request.sortKey !== undefined) {
            params.push([HierarchyURLBuilder.SORT_KEY_PARAM, request.sortKey]);
        }
        if (request.sortOrder !== undefined) {
            params.push([HierarchyURLBuilder.SORT_ORDER_PARAM, request.sortOrder]);
        }
        if (params.length > 0) {
            return "".concat(HierarchyURLBuilder.HIERARCHY_URL).concat(request.rootId, "?").concat((0, Url_1.encodeQueryString)(params));
        }
        else {
            return HierarchyURLBuilder.HIERARCHY_URL + request.rootId;
        }
    };
    HierarchyURLBuilder.HIERARCHY_URL = '/content/hierarchies/descendants/id/';
    HierarchyURLBuilder.MAXIMUM_DEPTH_PARAM = 'hierarchyDepth';
    HierarchyURLBuilder.MAXIMUM_PAGE_SIZE_PARAM = 'maxPageSize';
    HierarchyURLBuilder.LAST_EVALUATED_PARAM = 'pageCursor';
    HierarchyURLBuilder.SORT_KEY_PARAM = 'sortByKey';
    HierarchyURLBuilder.SORT_ORDER_PARAM = 'sortByOrder';
    return HierarchyURLBuilder;
}());
exports.HierarchyURLBuilder = HierarchyURLBuilder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXJsQnVpbGRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9jb29yZGluYXRvcnMvR2V0QnlIaWVyYXJjaHkvVXJsQnVpbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwwQ0FBdUQ7QUFFdkQ7SUFBQTtJQTBDQSxDQUFDO0lBbkNDLHNDQUFRLEdBQVIsVUFBUyxPQUF5QjtRQUNoQyxJQUFNLE1BQU0sR0FBZSxFQUFFLENBQUM7UUFFOUIsSUFBSSxPQUFPLENBQUMsWUFBWSxLQUFLLFNBQVMsRUFBRTtZQUN0QyxNQUFNLENBQUMsSUFBSSxDQUFDO2dCQUNWLG1CQUFtQixDQUFDLG1CQUFtQjtnQkFDdkMsT0FBTyxDQUFDLFlBQVksQ0FBQyxRQUFRLEVBQUU7YUFDaEMsQ0FBQyxDQUFDO1NBQ0o7UUFDRCxJQUFJLE9BQU8sQ0FBQyxlQUFlLEtBQUssU0FBUyxFQUFFO1lBQ3pDLE1BQU0sQ0FBQyxJQUFJLENBQUM7Z0JBQ1YsbUJBQW1CLENBQUMsdUJBQXVCO2dCQUMzQyxPQUFPLENBQUMsZUFBZSxDQUFDLFFBQVEsRUFBRTthQUNuQyxDQUFDLENBQUM7U0FDSjtRQUNELElBQUksT0FBTyxDQUFDLFVBQVUsS0FBSyxTQUFTLEVBQUU7WUFDcEMsTUFBTSxDQUFDLElBQUksQ0FBQztnQkFDVixtQkFBbUIsQ0FBQyxvQkFBb0I7Z0JBQ3hDLE9BQU8sQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFO2FBQzlCLENBQUMsQ0FBQztTQUNKO1FBQ0QsSUFBSSxPQUFPLENBQUMsT0FBTyxLQUFLLFNBQVMsRUFBRTtZQUNqQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsbUJBQW1CLENBQUMsY0FBYyxFQUFFLE9BQU8sQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO1NBQ3BFO1FBQ0QsSUFBSSxPQUFPLENBQUMsU0FBUyxLQUFLLFNBQVMsRUFBRTtZQUNuQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsbUJBQW1CLENBQUMsZ0JBQWdCLEVBQUUsT0FBTyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUM7U0FDeEU7UUFDRCxJQUFJLE1BQU0sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO1lBQ3JCLE9BQU8sVUFBRyxtQkFBbUIsQ0FBQyxhQUFhLFNBQ3pDLE9BQU8sQ0FBQyxNQUFNLGNBQ1osSUFBQSx1QkFBaUIsRUFBQyxNQUFNLENBQUMsQ0FBRSxDQUFDO1NBQ2pDO2FBQU07WUFDTCxPQUFPLG1CQUFtQixDQUFDLGFBQWEsR0FBRyxPQUFPLENBQUMsTUFBTSxDQUFDO1NBQzNEO0lBQ0gsQ0FBQztJQXhDTSxpQ0FBYSxHQUFHLHNDQUFzQyxDQUFDO0lBQ3ZELHVDQUFtQixHQUFHLGdCQUFnQixDQUFDO0lBQ3ZDLDJDQUF1QixHQUFHLGFBQWEsQ0FBQztJQUN4Qyx3Q0FBb0IsR0FBRyxZQUFZLENBQUM7SUFDcEMsa0NBQWMsR0FBRyxXQUFXLENBQUM7SUFDN0Isb0NBQWdCLEdBQUcsYUFBYSxDQUFDO0lBb0MxQywwQkFBQztDQUFBLEFBMUNELElBMENDO0FBMUNZLGtEQUFtQiJ9